// File for logic corresponding to subscription form component
import { Component } from 'js-component-framework';

/**
 * Component for Subscription Form
 */
export default class SubscriptionForm extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);
    document.querySelector('.is-submit input')
      .addEventListener('click', () => {
        const names = ['iMagId', 'i6Ky', 'iOrderType', 'iMemberType', 'iPromo', 'iOrdBillEmail', 'iOrdBillFName', 'iOrdBillLName'];

        const submissionParams = names.map((name) => {
          const element = document.getElementsByName(name);
          if (element.length && element[0].value) {
            return `&${name}=${element[0].value}`;
          }
          return null;
        }).join('');

        if (submissionParams) {
          const palmCoastUrl = '//pages.mailer2.bassmaster.com/page.aspx?QS=38dfbe491fab00ea16e7b42a91a9ea0c02ac2de0cfc43cb908256d144220b1f7';
          const submissionUrl = `${window.location.protocol}${palmCoastUrl}${submissionParams}&submit=Submit&SignupURL=www.bassmaster.com`;
          const XHR = new XMLHttpRequest();
          XHR.open('GET', encodeURI(submissionUrl));
          XHR.send();
        }
      }, false);
  }
}
